<template>
  <div>
    <a-modal
      v-model="sendDialogVisible"
      :title="costSendTit"
      on-ok="handleOk"
      width="500px"
      :mask-closable="false"
      @cancel="handleCancel"
    >
      <div>
        <div class="title-content">
          {{ $t('message["497"]') }}
        </div>
        <div>
          <a-tree-select
            style="width:400px"
            :tree-data="treeDatas"
            :value="value"
            :show-checked-strategy="SHOW_PARENT"
            tree-checkable
            :search-placeholder="selectPlaceholder"
            @change="onChange"
          >
            <a-icon
              slot="suffixIcon"
              type="smile"
            />
          </a-tree-select>
        </div>
      </div>
      <template slot="footer">
        <a-button
          key="back"
          @click="handleCancel"
        >
          {{ $t('message["896"]') }}
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="saveLoading"
          @click="handleOk"
        >
          {{ $t('message["915"]') }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { TreeSelect } from 'ant-design-vue'
const SHOW_PARENT = TreeSelect.SHOW_PARENT
export default {
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      value: [],
      SHOW_PARENT,
      treeDatas: [],
      sendParams: {
        id: this.id,
        sendtoid: []
      }
    }
  },
  computed: {
    ...mapState('costMaintain/costDetail', ['sendDialogVisible', 'radioTypeDatas', 'saveLoading', 'sendSelectLists']),
    costSendTit () {
      return this.$t('message["104"]')
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    }
  },
  watch: {
    id (val) {
      if (!val) {
        return
      }
      this.sendParams.id = val
    },
    sendDialogVisible (val) {
      if (val) {
        this.value = []
      }
    },
    sendSelectLists (val) {
      if (!val) {
        return
      }
      let tempv = []
      if (Array.isArray(val)) {
        val.map(value => {
          let json = {
            title: value.name,
            value: value.keyname + '-' + value.id,
            key: value.keyname + '-' + value.id,
            children: []
          }
          if (value.children) {
            value.children.map(values => {
              let json2 = {
                title: values.name,
                value: value.keyname + '-' + value.id + '|' + values.keyname + '-' + values.id,
                key: value.keyname + '-' + value.id + '|' + values.keyname + '-' + values.id,
                children: []
              }
              if (values.children) {
                values.children.map(item => {
                  json2.children.push({
                    title: item.name,
                    value: value.keyname + '-' + value.id + '|' + values.keyname + '-' + values.id + '|' + item.keyname + '-' + item.id,
                    key: value.keyname + '-' + value.id + '|' + values.keyname + '-' + values.id + '|' + item.keyname + '-' + item.id
                  })
                })
              }
              json.children.push(json2)
            })
          }
          tempv.push(json)
        })
      }
      this.treeDatas = tempv
    }
  },
  methods: {
    ...mapMutations('costMaintain/costDetail', ['setSendDialogVisible', 'setSaveLoading']),
    ...mapActions('costMaintain/costDetail', ['fetchCostRecordSend']),
    onChange (value) {
      this.value = value
      let sendJson = []
      if (Array.isArray(value)) {
        value.map(vvs => {
          const tempv = vvs.split('|')
          if (tempv.length === 1) {
            const vs = tempv[0].split('-')
            const json = {}
            json[vs[0]] = vs[1]
            sendJson.push(json)
          } else if (tempv.length === 2) {
            const roleidArr = tempv[0].split('-')
            const groupidArr = tempv[1].split('-')
            const json = {}
            json[roleidArr[0]] = roleidArr[1]
            json[groupidArr[0]] = groupidArr[1]
            if (sendJson.length === 0) {
              sendJson.push(json)
            } else {
              let isTrue = false
              sendJson.some(item => {
                if (item[roleidArr[0]] === roleidArr[1] && item[groupidArr[0]] === groupidArr[1]) {
                  item = json
                  isTrue = true
                }
              })
              if (isTrue) {
                return
              }
              sendJson.push(json)
            }
          } else if (tempv.length === 3) {
            const roleidArr = tempv[0].split('-')
            const groupidArr = tempv[1].split('-')
            const useridArr = tempv[2].split('-')
            const json = {}
            json[roleidArr[0]] = roleidArr[1]
            json[groupidArr[0]] = groupidArr[1]
            json[useridArr[0]] = [useridArr[1]]
            if (sendJson.length === 0) {
              sendJson.push(json)
            } else {
              let isTrue = false
              sendJson.some(item => {
                if (item[roleidArr[0]] === roleidArr[1] && item[groupidArr[0]] === groupidArr[1]) {
                  item[useridArr[0]].push(useridArr[1])
                  isTrue = true
                  return true
                }
              })
              if (isTrue) {
                return
              }
              sendJson.push(json)
            }
          }
        })
      }
      console.log(sendJson)
      this.sendParams.sendtoid = sendJson
    },
    // 添加小组---保存操作
    handleOk (e) {
      this.setSaveLoading(true)
      this.fetchCostRecordSend(this.sendParams)
    },
    // 添加小组---取消操作
    handleCancel (e) {
      this.setSendDialogVisible(false)
      this.setSaveLoading(false)
    }
  }
}
</script>
<style lang="scss" scoped>
.title-content {
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #b3b3b3;
  margin-bottom: 16px;
}
</style>
